import { createAppSelector } from 'store'
import { instanceOfFilterDescriptor, isGroupedFilters } from 'utils/QueryHelpers'

import { CompositeFilterDescriptor, FilterDescriptor } from './types'

export const selectGridFilters = createAppSelector(
  (state) => state.grid.filter,
  (gridFilter) => gridFilter.filters
)

export const selectGridFilterByFilterId = createAppSelector(
  (state) => state.grid.filter,
  (filterDescriptor) => (filterId: string) => {
    return findFilterByFilterId(flatFilters(filterDescriptor), filterId)
  }
)

const flatFilters = (filterDescriptor: CompositeFilterDescriptor): FilterDescriptor[] => {
  return filterDescriptor.filters
    .reduce((previousValue: FilterDescriptor[], currentValue): FilterDescriptor[] => {
      if (isGroupedFilters(currentValue)) {
        const filter = flatFilters(currentValue)
        if (filter) {
          return previousValue.concat(filter)
        }
        return previousValue
      }

      if (instanceOfFilterDescriptor(currentValue)) {
        return previousValue.concat(currentValue)
      }

      return previousValue
    }, [])
    .filter((x) => !!x.id)
}

const findFilterByFilterId = (filters: FilterDescriptor[], filterId: string) => {
  return filters.find((filter) => {
    if (instanceOfFilterDescriptor(filter)) {
      return filter?.id === filterId
    }
    return false
  })
}
